import { HTLCPublicClient, } from '@train-protocol/sdk';
import { TronRpcClient } from '../rpc.js';
import { getUserLockDetails } from './public/getUserLockDetails.js';
import { getSolverLockDetails } from './public/getSolverLockDetails.js';
import { recoverSwap } from './public/recoverSwap.js';
import { getTransaction } from './public/getTransaction.js';
import { getTrc20Allowance } from './public/getTrc20Allowance.js';
export class TronHTLCPublicClient extends HTLCPublicClient {
    constructor(config) {
        super();
        this.rpc = new TronRpcClient(config.rpcUrl, config.apiKey);
        this.apiKey = config.apiKey;
    }
    async getUserLockDetails(params) {
        return getUserLockDetails(this.rpc, params);
    }
    async getSolverLockDetails(params, nodeUrl) {
        return getSolverLockDetails(params, nodeUrl, this.apiKey);
    }
    async recoverSwap(txHash, network) {
        return recoverSwap(this.rpc, txHash, network);
    }
    async getTransaction(txHash) {
        return getTransaction(this.rpc, txHash);
    }
    async getTrc20Allowance(token, owner, spender) {
        return getTrc20Allowance(this.rpc, token, owner, spender);
    }
}
